<template>
    <csv-upload-card :validator="usersCsvValidator" @selected="emit('selected', $event)" />
</template>

<script lang="ts" setup>
import CsvUploadCard from '~/components/general/CsvUploadCard.vue';
import { usersCsvValidator } from './validateUsersCsv';

const emit = defineEmits<{
    selected: [file: File];
}>();
</script>
